/* eslint-disable max-len */
import { createSvgIcon } from "../utils";

const NoticeError = createSvgIcon(
    <>
        <path d="M13.514 12.125C16.598 6.708 18.14 4 20.466 4c2.325 0 3.867 2.708 6.951 8.125l6.739 11.833c3.029 5.32 4.544 7.98 3.387 9.969-1.157 1.99-4.218 1.99-10.34 1.99H13.728c-6.121 0-9.182 0-10.339-1.99-1.156-1.99.358-4.65 3.387-9.97l6.739-11.832z" />
        <path
            d="M20.766 26.512c.997 0 1.8.759 1.8 1.713 0 .954-.803 1.692-1.8 1.692-.976 0-1.8-.738-1.8-1.692s.824-1.713 1.8-1.713zm-1.41-11.906h2.84v10.106h-2.84V14.606z"
            fill="#fff"
        />
    </>,
    "NoticeError",
);

export default NoticeError;
